import { Interweave } from 'interweave'
import React, { useEffect, useRef } from 'react'

export const getIpadSafeUrl = (url: string) => {
    if (!url) {
        return url
    }
    // this parameter is read from IOS app in order to understand if the link has to be opened inside the app or outside in safari
    if (url.includes('?')) {
        return url + '&target=out'
    } else if (url.includes('target=out')) {
        return url
    } else {
        return url + '?&target=out'
    }
}

interface Props {
    innerHTML: { __html: string }
    className?: string
}

// This sanitizer is required in order to ensure links are opened with the target=out parameter in URL
// This is necessary for embedded IPAD applications in order to open web pages outside web viewer
const fixExternalLinks = (containerRef: any) => {
    let allLinks = containerRef.current.querySelectorAll('a')
    for (let i = 0; i < allLinks.length; i++) {
        let link = allLinks[i]
        link.href = getIpadSafeUrl(link.href)
    }
}

export const BareHtml = {
    p: (props: Props) => {
        const containerRef = useRef(null)
        useEffect(() => {
            fixExternalLinks(containerRef)
        }, [props.innerHTML.__html])
        return (
            <p ref={containerRef} className={props.className}>
                <Interweave content={props.innerHTML.__html} noHtml/>
            </p>
        )
    },
    div: (props: Props) => {
        const containerRef = useRef(null)
        useEffect(() => {
            fixExternalLinks(containerRef)
        }, [props.innerHTML.__html])
        return (
            <div ref={containerRef} className={props.className}>
                <Interweave content={props.innerHTML.__html} noHtml/>
            </div>
        )
    },
}
